var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullscreenActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4h3a1 1 0 010 2h-4a1 1 0 01-1-1V1a1 1 0 012 0v3zM9 8a1 1 0 10-2.001.001A1 1 0 009 8zM1 12h3v3a1 1 0 002 0v-4a.997.997 0 00-1-1H1a1 1 0 000 2z",
    fill: "#fff"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEyIDRMMTUgNEMxNS41NTE5IDQgMTYgNC40NDgxIDE2IDVDMTYgNS41NTE5IDE1LjU1MTkgNiAxNSA2TDExIDZDMTAuNDQ4MSA2IDEwIDUuNTUxOSAxMCA1VjFDMTAgMC40NDgxMDEgMTAuNDQ4MSAwIDExIDBDMTEuNTUxOSAwIDEyIDAuNDQ4MSAxMiAxVjRaIiBmaWxsPSJ3aGl0ZSIvPgo8cGF0aCBkPSJNOSA4QzkgNy40NDgxIDguNTUxOSA3IDggN0M3LjQ0ODEgNyA3IDcuNDQ4MSA3IDhDNyA4LjU1MTkgNy40NDgxIDkgOCA5QzguNTUxOSA5IDkgOC41NTE5IDkgOFoiIGZpbGw9IndoaXRlIi8+CjxwYXRoIGQ9Ik0xIDEySDRMNCAxNUM0IDE1LjU1MTkgNC40NDgxIDE2IDUgMTZDNS41NTE5IDE2IDYgMTUuNTUxOSA2IDE1TDYgMTFDNiAxMC43MjQgNS44ODc5NyAxMC40NzQgNS43MDY5NiAxMC4yOTNDNS41MjU5NSAxMC4xMTIgNS4yNzU5NSAxMCA1IDEwSDAuOTk5OTk5QzAuNDQ4MDk5IDEwIDAgMTAuNDQ4MSAwIDExQzAgMTEuNTUxOSAwLjQ0ODEgMTIgMSAxMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";
export { SvgFullscreenActive as ReactComponent };